import styled from 'styled-components';

export default styled.div`
  position: fixed;
  z-index: 1;
  inset: 0;
  transition: all 0.4s cubic-bezier(0.17, 0.84, 0.44, 1);
  backdrop-filter: blur(5px);
`;
